import ga from 'lib/ga'

app.$once('app:setup', () => {
  if (!app.envIsProduction) return

  // Adicionando google analytics
  if (ga.id) ga.initialize({ router: app.router })
})
